module.exports = __webpack_public_path__ + "files/b38a1d6040f87de773947153960f4b9e.svg";